import styled from "styled-components";

export const Header = styled.h2`
  font-family: "Pretendard";
  font-size: 24px;
  font-weight: bold;
  line-height: 1.4;
  letter-spacing: 0.04px;
  color: #000;
  text-align: left;
  width: 328px;
  margin: auto;
  margin-top: 32px;
  margin-bottom: 32px;
  
  span {
  width: 93px;
  height: 18px;
  flex-grow: 0;
  font-family: "Pretendard";
  font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.06px;
  text-align: center;
  color: #263628;
  }
`